import React from 'react';
import { Button, Tooltip } from 'antd';
import { TimeKeeperSystemType } from '@/DTOS/TimeKeeperSystemType/Response/TimeKeeperSystemType';
import { EditOutlined} from '@ant-design/icons';

export const TimeKeeperSystemTypeColumn = (
  handleEdit: (record: TimeKeeperSystemType) => void
) => [
  
  {
    title: 'System Type Id',
    dataIndex: 'id',
    key: 'id',
    hidden: true,
  },
  {
    title: 'Nume',
    dataIndex: 'name',
    key: 'name',
    
  },
  {
    title: 'Locatia',
    dataIndex: 'location',
    key: 'location',
    render: (text: string) => (
          <Tooltip title={text}>
            <div className="ellipsis-cell">{text}</div>
          </Tooltip>
        )
  },
  {
    title: 'Ip',
    dataIndex: 'ip',
    key: 'ip',
  },
  {
    title: 'Port',
    dataIndex: 'port',
    key: 'port',
  },
  {
    title: 'Utilizator',
    dataIndex: 'user',
    key: 'user',
  },
  {
    title: 'Actiune',
    key: 'actions',
    render: (record: TimeKeeperSystemType) => (
      <Tooltip title='Modifica'>
      <Button onClick={() => handleEdit(record)} icon={<EditOutlined/>}></Button>
      </Tooltip>
    ),
    width: 120,
    fixed: 'right',
  },
];
